export const SAVE_ORDERFLOWADD = 'SAVE_ORDERFLOWADD'
export const SAVE_ORDERFLOWACTIVE = 'SAVE_ORDERFLOWACTIVE'
export const SHOW_HOUSE_INFO = 'SHOW_HOUSE_INFO'



// WEBPACK FOOTER //
// ./src/story/mutation-types.js